<template>
  <div id="multiple-feature-popup" class="rounded" @mousedown="initResize">
    <div :id="popupResizableId" :style="{ width: currentWidth, height: currentHeight }">
      <b-row class="mb-1">
        <b-col id="feature-popup-header">
          <h6 v-if="featurePopupHeader" class="font-weight-bold">{{featurePopupHeader}}</h6>
        </b-col>
        <b-col md="auto">
          <a href="#" id="feature-popup-close" class="float-right text-secondary" @click="closePopup"></a>
        </b-col>
      </b-row>
      <div :id="popupContentId">
        <div v-for="featureData in multipleFeaturePopupData" :key="featureData.name">
          <b-button v-b-toggle="featureData.name.toString()" class="mb-2 width100" variant="primary">{{ featureData.name }}</b-button>
          <b-collapse :id="featureData.name.toString()">
            <div class="table-responsive">
              <table class="table table-bordered table-striped col-md-12">
                <tbody>
                  <tr v-for="attr in featureData.attributes" :key="attr.key" v-if="keyIsNotIgnored(attr.key)">
                    <td class="width50">
                      {{attr.key}}
                    </td>
                    <td class="width50" v-if="attr.isLink">
                      <a :href="attr.val" target="_blank" rel="noopener noreferrer">{{attr.val}}</a>
                    </td>
                    <td v-else-if="attr.isFileList">
                      <ul>
                        <li v-for="item in attr.val" :key="item.path">
                          <a href="#" @click="downloadFile(item)"> {{ item.name }} </a>
                        </li>
                      </ul>
                    </td>
                    <td class="width50" v-else>
                      <pre class="feature-popup-preformatted">{{attr.val}}</pre>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SELECT_FEATURE_POPUP_HIDE } from "../store/mutations.type";
import SettingsInstance from "../api/SettingsInstance";

const START_WIDTH = 700;
const START_HEIGHT = 400;

export default {
  name: "FeaturePopup",
  data: function() {
    return {
      popupContentId: "multiple-feature-popup-content",
      popupResizableId: "multiple-feature-popup-resizable",
      startX: null,
      startY: null,
      startWidth: START_WIDTH,
      width: START_WIDTH,
      minWidth: 120,
      maxWidth: 850,
      startHeight: START_HEIGHT,
      height: START_HEIGHT,
      minHeight: 100,
      maxHeight: 850,
      ignoredKeys: ['id']
    };
  },
  computed: {
    ...mapGetters(["multipleFeaturePopupData", "featurePopupHeader", "featurePopupHtml"]),
    currentWidth() { return this.width + "px"; },
    currentHeight() { return this.height + "px"; }
  },
  mounted() {
    let self = this;
    self.$store.watch(
      () => self.$store.getters.multipleFeaturePopupPosition,
      (value, oldValue) => {
        var el = document.getElementById(self.popupContentId);
        el.scrollTop = 0;
        this.width = START_WIDTH;
        this.height = START_HEIGHT;
      }
    );
  },
  methods: {
    async downloadFile(item){
      if(item.apiAction && item.apiAction=="getStawkiZalacznikiByPath"){
        let baseUrl = SettingsInstance.baseApiUrl.trim("/");
        baseUrl += '/stawki_zalaczniki/' + item.path;
        window.location = baseUrl;
      }
    },
    keyIsNotIgnored(key) {
      return !this.ignoredKeys.includes(key);
    },
    closePopup() {
      this.$store.commit(SELECT_FEATURE_POPUP_HIDE);
    },
    initResize(e) {
      if (e.target && e.target.id === this.popupResizableId) {
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.startWidth = this.width;
        this.startHeight = this.height;
        
        document.documentElement.addEventListener("mousemove", this.resize, false);
        document.documentElement.addEventListener("mouseup", this.stopResize, false);
      }
    },
    resize(e) {
      e.stopPropagation();
      e.preventDefault();

      const width = this.startWidth + e.clientX - this.startX;
      if (width >= this.minWidth && width <= this.maxWidth) {
        this.width = width;
      }

      const height = this.startHeight + e.clientY - this.startY;
      if (height >= this.minHeight && height <= this.maxHeight) {
        this.height = height;
      }
    },
    stopResize(e) {
      document.documentElement.removeEventListener("mousemove", this.resize, false);
      document.documentElement.removeEventListener("mouseup", this.stopResize, false);
    }
  }
};
</script>

<style>
.width50 {
  width: 50%
}

.width100 {
  width: 100%
}
</style>